import Vue from 'vue'
import Router from 'vue-router'
//import CheckAge from 'components/checkage'
import Home from 'components/home'
import faq from 'components/faq'
import Regolamento from 'components/regulation'
import Privacy from 'components/privacy'
import cookie from 'components/cookie'
import admin from 'components/admin'

import loginasgod from 'components/loginasgod'



import Calcolatore from 'components/calcolatore'
import Login from 'components/areaRiservata'
import Account from 'components/account'

import addClient from 'components/addClient'
import offerte from 'components/offerte'
import superbonus from 'components/superbonus'

import editInvoice from 'components/editCalc'

import acceptInvoice from 'components/acceptInvoice'
import loadDocuments from 'components/loadDocuments'
import editDocument from 'components/editDocuments'

import Confirm from 'components/confirm'
import Forgotpassword from 'components/forgotpassword'
import Recoverypassword from 'components/recoverypassword'

import showProducts from 'components/showProducts'
import pratiche from 'components/pratiche'
import end from 'components/end'
import notActive from 'components/notActive'
import complateEneaData from 'components/complateEneaData'

import paymentError from 'components/paymentError'
import paymentSuccess from 'components/paymentSuccess'

import cobrowsing from 'components/cobrowsing'

// NEW FLOW 02.08.2021
import flowSettings from 'components/flowSettings'
import editDocumentCDP from 'components/flowSettings/editDocumentCDP.vue'
import contact from 'components/contact'
import cessioni from 'components/cessioni'

import testIframe from 'components/testIframe'


//import Forgotpassword from 'components/forgotpassword'
//import Recoverypassword from 'components/recoverypassword'
//import ComplateRegistration from 'components/ComplateRegistration'
//import Receipts from 'components/receipts'


import store from '../store'


Vue.use(Router)

const ifNotAuthenticated = (to, from, next) => {
  if (!store.getters.isAuthenticated || !store.getters.isAuthenticated) {
    next()
    return
  }
  next('/')
}

const ifAuthenticated = (to, from, next) => {
  if (store.getters.isProfileLoaded || store.getters.isAuthenticated) {
    next()
    return
  }
  next('/login')
}

const moment = require('moment')

const ifActive = (to, from, next) => {

  var finish = moment(process.env.FINISH)
  if ( moment() < finish ) {
    next()
    return
  }
  next('/end')

}

const ifStart = (to, from, next) => {

  var start = moment(process.env.START)
  if ( moment() > start ) {
    next()
    return
  }
  next('/notActive')

}


export default new Router({
  mode: 'history',
  //base: '/nttest/vaillantecobonus/',
  base: '/',
  routes: [
	{
    path: '/',
    name: 'Home',
    component: Home,
	  beforeEnter: guards([  ifStart, ifActive ]),

  },
  {
    path: '/testIframe',
    name: 'testIframe',
    component: testIframe,
	  beforeEnter: guards([  ifStart, ifActive, ifAuthenticated ]),

  },
  {
    path: '/contact',
    name: 'contact',
    component: contact,
	  beforeEnter: guards([  ifStart, ifActive, ifAuthenticated ]),

  },
  {
    path: '/faq',
    name: 'faq',
    component: faq,
	  beforeEnter: guards([  ifStart, ifActive, ifAuthenticated ]),

  },
  {
    path: '/cessioni',
    name: 'cessioni',
    component: cessioni,
	  beforeEnter: guards([  ifStart, ifActive, ifAuthenticated ]),

  },
  {
    path: '/paymentError/:id',
    name: 'paymentError',
    component: paymentError,
    beforeEnter: guards([  ifStart, ifActive, ifAuthenticated ]),

  },

  {
    path: '/paymentSuccess/:id',
    name: 'paymentSuccess',
    component: paymentSuccess,
    beforeEnter: guards([  ifStart, ifActive, ifAuthenticated ]),

  },

  {
    path: '/registration',
    name: 'addClient',
    component: addClient,
	  beforeEnter: guards([  ifStart, ifActive, ifNotAuthenticated ]),

  },
  {
    path: '/confirm',
    name: 'Confirm',
    component: Confirm,
    beforeEnter: ifNotAuthenticated,
  },
  {
    path: '/forgot-password',
    name: 'Forgotpassword',
    component: Forgotpassword,
    beforeEnter: ifNotAuthenticated,
  },
  {
    path: '/recovery-password',
    name: 'Recoverypassword',
    component: Recoverypassword,
    beforeEnter: ifNotAuthenticated,

  },
  {
    path: '/Calcolatore',
    name: 'Calcolatore',
    component: Calcolatore,
	  beforeEnter: guards([ ifStart,  ifActive,ifAuthenticated ]),

  },
  {
    path: '/account',
    name: 'Account',
    component: Account,
    beforeEnter: guards([  ifStart, ifActive,ifAuthenticated ]),

  },
  {
    path: '/cobrowsing',
    name: 'CoBrowsing',
    component: cobrowsing,
    beforeEnter: guards([  ifStart, ifActive,ifAuthenticated ]),

  },

  {
    path: '/offerte',
    name: 'offerte',
    component: offerte,
    beforeEnter: guards([  ifStart, ifActive,ifAuthenticated ]),

  },
  {
    path: '/superbonus',
    name: 'superbonus',
    component: superbonus,
    beforeEnter: guards([  ifStart, ifActive,ifAuthenticated ]),

  },
  {
    path: '/acceptInvoice',
    name: 'acceptInvoice',
    component: acceptInvoice,
    //beforeEnter: ifAuthenticated
  },
  {
    path: '/editInvoice',
    name: 'editInvoice',
    component: editInvoice,
    //beforeEnter: ifAuthenticated
  },

  {
    path: '/loadDocuments',
    name: 'loadDocuments',
    component: loadDocuments,
    beforeEnter: guards([ ifStart,  ifActive, ifAuthenticated ]),
  },
  {
    path: '/editDocument',
    name: 'editDocument',
    component: editDocument,
    beforeEnter: guards([ ifStart,  ifActive, ifAuthenticated ]),
  },
  {
    path: '/pratiche',
    name: 'pratiche',
    component: pratiche,
    beforeEnter: guards([  ifStart, ifActive, ifAuthenticated ]),

  },
  {
    path: '/complateEneaData',
    name: 'complateEneaData',
    component: complateEneaData,
    beforeEnter: guards([  ifStart, ifActive, ifAuthenticated ]),

  },


	{
    path: '/login',
    name: 'Login',
    component: Login,
    beforeEnter: guards([  ifStart, ifActive, ifNotAuthenticated ]),
  },

  {
    path: '/loginasgod',
    name: 'loginasgod',
    component: loginasgod,
  },


	{
    path: '/privacy',
    name: 'Privacy',
    component: Privacy,
	 // beforeEnter: ifComplateAccount,
    },
    {
      path: '/validUser',
      name: 'admin',
      component: admin,
  	 // beforeEnter: ifComplateAccount,
      },
    {
      path: '/cookie',
      name: 'cookie',
      component: cookie,
     // beforeEnter: ifComplateAccount,
      },
	{
    path: '/regulation',
    name: 'regulation',
    component: Regolamento,
	 // beforeEnter: ifComplateAccount,
    },
    {
      path: '/end',
      name: 'end',
      component: end,
     // beforeEnter: ifComplateAccount,
      },
      {
        path: '/notActive',
        name: 'notActive',
        component: notActive,
       // beforeEnter: ifComplateAccount,
        },

      // NEW FLOW 02.08.2021
      {
        path: '/flowSettings',
        name: 'flowSettings',
        component: flowSettings,
        beforeEnter: guards([  ifStart, ifActive, ifAuthenticated ]),

      },
      {
        path: '/editDocumentCDP',
        name: 'editDocumentCDP',
        component: editDocumentCDP,
        beforeEnter: guards([  ifStart, ifActive, ifAuthenticated ]),

      },


  ],
})


// allows using multiple guards for routes
function guards(guards)
{
    return async (to, from, next) => {

        // a flag to discard remaining guards
        let changed = false;

        // handle next for multiple guards
        const mNext = function (value)
        {
            // prevent calling next after it is already resolved with a value
            if(changed) return;

            // if we have 'value' reslove next with the value and set changed flag
            if(typeof value != 'undefined')
            {
                changed = true;
                next(value);
            }
        };

        // call guards
        for (let i = 0; i < guards.length; i++)
        {
            if(changed) break;
            await guards[i](to, from, mNext);
        }

        // move on if none of guards resolved next with a value
        if(!changed) next();

    }
}



// WEBPACK FOOTER //
// ./src/router/index.js